import gql from "graphql-tag";
import { PRODUCT_THUMBNAIL, MOBILE_PRODUCT_THUMBNAIL } from "@components/ProductPage/ProductThumbnail/queries";

export const HUGE_SALE = gql`
  ${PRODUCT_THUMBNAIL}
  query todayHugeSale($first: Int) {
    todayHugeSale {
      id
      eventDate
      products(first: $first) {
        edges {
          node {
            ...productThumbnail
          }
        }
      }
    }
  }
`;

export const MOBILE_HUGE_SALE = gql`
  ${MOBILE_PRODUCT_THUMBNAIL}
  query mobileTodayHugeSale($first: Int) {
    todayHugeSale {
      id
      eventDate
      products(first: $first) {
        edges {
          node {
            ...mobileProductThumbnail
          }
        }
      }
    }
  }
`;
